<help-trigger>
  <a
    onclick={event => toggle(event)}
    class="dfk-sans-serif fw-bold text-decoration-none pt-1"
  >?</a>

  <script>
    export default class {
      toggle(event) {
        event.preventDefault()

        this.bus.emit('toggle-fly-in')
        // const h = this.props.onClick
        // if (h) h(event)
      }
    }
  </script>
</help-trigger>